module.exports = __webpack_public_path__ + "img/blog-video-circle-small.a8609447.svg";